module.exports = setNonEnumerable;

function setNonEnumerable(object, key, value) {
    Object.defineProperty(object, key, {
        value: value,
        writable: true,
        configurable: true,
        enumerable: false
    });
}



//////////////////
// WEBPACK FOOTER
// ./~/observ-array/lib/set-non-enumerable.js
// module id = 15
// module chunks = 0